import { createFileRoute } from '@tanstack/react-router';
import { PageHeader } from '@/components/shared/PageHeader';
import { HealthDashboard } from '@/components/features/health/HealthDashboard';
import { ServiceStatusCard } from '@/components/features/health/ServiceStatusCard';
import { QueueMetrics } from '@/components/features/health/QueueMetrics';
import { RefreshButton } from '@/components/shared/RefreshButton';
import { Badge } from '@/components/ui/badge';
import { LoadingState } from '@/components/shared/LoadingState';
import { ErrorState } from '@/components/shared/ErrorState';
import { useHealth } from '@/lib/hooks';
import { formatDate } from '@/utils/formatters';

export const Route = createFileRoute('/_auth/_admin/admin/health/')({
  component: HealthComponent,
});

function HealthComponent() {
  const { data, isLoading, isError, error, refetch } = useHealth(true);

  if (isLoading) {
    return <LoadingState />;
  }

  if (isError) {
    return <ErrorState message={error.message} title={error.name} />;
  }

  const health = data!;
  const statusVariant = 
    health.status === 'ok' ? 'default' : 
    health.status === 'warning' ? 'secondary' : 
    'destructive';

  return (
    <div className="space-y-6">
      <PageHeader
        title="System Health"
        description={`Last updated: ${formatDate(health.timestamp, 'full')}`}
        action={
          <div className="flex items-center gap-2">
            <Badge variant={statusVariant}>{health.status.toUpperCase()}</Badge>
            <RefreshButton onClick={refetch} />
          </div>
        }
      />

      <HealthDashboard />

      <div className="grid gap-6 md:grid-cols-3">
        <ServiceStatusCard
          name="Database"
          status={health.services.database.status}
          message={health.services.database.message}
        />
        <ServiceStatusCard
          name="Redis"
          status={health.services.redis.status}
          message={health.services.redis.message}
        />
        <ServiceStatusCard
          name="TronGrid"
          status={health.services.trongrid.status}
          message={health.services.trongrid.message}
        />
      </div>

      <div className="grid gap-6 md:grid-cols-2">
        <QueueMetrics pendingJobs={health.metrics.queue.pending_jobs} failedJobs={health.metrics.queue.failed_jobs} />
        {/*<MetricsCard*/}
        {/*  title="Wallet Metrics"*/}
        {/*  metrics={health.metrics.wallets}*/}
        {/*/>*/}
      </div>
    </div>
  );
}
